import { makeAutoObservable, runInAction } from "mobx";
import {
  PropertiesService,
  type SearchFilters,
  type SearchResult,
} from "../services/PropertiesService";
import type { Imovel } from "../scripts/db";

export { type SearchFilters };

export class FilterStore {
  filters: SearchFilters = {};
  results: Imovel[] = [];
  totalCount = 0;
  currentPage = 1;
  pageSize = 12;
  isLoading = false;
  error: string | null = null;
  neighborhoods: string[] = [];
  cities: string[] = [];

  private service = new PropertiesService();

  constructor() {
    makeAutoObservable(this);
  }

  setFilter<K extends keyof SearchFilters>(
    key: K,
    value: SearchFilters[K],
  ): void {
    this.filters[key] = value;
  }

  setFilters(partial: Partial<SearchFilters>): void {
    this.filters = { ...partial };
  }

  resetFilters(): void {
    this.filters = {};
    this.currentPage = 1;
    this.results = [];
    this.totalCount = 0;
  }

  async loadNeighborhoods(): Promise<void> {
    try {
      const result = await this.service.getNeighborhoods();
      runInAction(() => {
        this.neighborhoods = result;
      });
    } catch {
      // silencia erro no carregamento de bairros
    }
  }

  async loadCities(): Promise<void> {
    try {
      const result = await this.service.getCities();
      runInAction(() => {
        this.cities = result;
      });
    } catch {
      // silencia erro no carregamento de cidades
    }
  }

  async search(): Promise<void> {
    this.isLoading = true;
    this.error = null;
    try {
      const filters = {
        ...this.filters,
        page: this.currentPage,
        pageSize: this.pageSize,
      };
      const result: SearchResult = await this.service.search(filters);
      runInAction(() => {
        this.results = result.results;
        this.totalCount = result.total;
        this.isLoading = false;
      });
    } catch (err) {
      runInAction(() => {
        this.error = err instanceof Error ? err.message : "Search failed";
        this.isLoading = false;
      });
    }
  }

  async loadPage(page: number): Promise<void> {
    this.currentPage = page;
    await this.search();
  }

  async setPageSize(size: number): Promise<void> {
    this.pageSize = size;
    this.currentPage = 1;
    await this.search();
  }
}
